<template>
  <BTable
    v-bind="$attrs"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <template #item.filename="{ item }">
      <div v-html="getFilename(item)" />
    </template>
  </BTable>
</template>

<script>
import BTableSimple from '@/components/tables/BTableCommon/BTableSimple.vue'
import { dateFormatterIgnoreTz } from '@/helpers/dateFormatter'
import { UserAction } from '@/typings/api/Marks/EventLog'
import { MarksFilesApi } from '@/api/resources/Marks'

const TABLE_HEADERS = [
  {
    text: 'id',
    value: 'uah_id',
    width: 'auto',
    sortable: false,
  },
  {
    text: 'Дата и время',
    value: 'created_at',
    sortable: false,
    field: (v) => dateFormatterIgnoreTz(v, 'DD.MM.YYYY HH:mm:ss'),
  },
  {
    text: 'Пользователь',
    value: 'user',
    sortable: false,
  },
  {
    text: 'Действие',
    value: 'action',
    sortable: false,
    field: (v) => {
      switch (v) {
        case UserAction.CREATE_PROCEDURE:
          return 'Создание процедуры'
        case UserAction.MARKS_UPLOAD:
          return 'Загрузка данных из системы Эксперт'
        case UserAction.MARKS_SAVE:
          return 'Обработка данных из системы Эксперт'
        case UserAction.OTHER_MARKS:
          return 'Наличие данных для дальнейшей работы (в т.ч. поступившие из внешних систем)'
        case UserAction.QUESTIONS_UPLOAD:
          return 'Загрузка ключей'
        case UserAction.QUESTIONS_SAVE:
          return 'Обработка ключей'
        case UserAction.ANSWER_QUESTION_SYNC:
          return 'Синхронизация ключей и ответов учеников'
        case UserAction.CALCULATE_MARKS:
          return 'Перевод ответов в баллы'
        case UserAction.VEER_CREATION:
          return 'Формирование веера'
        case UserAction.VEER_UPLOAD:
          return 'Загрузка обработанного веера'
        case UserAction.VEER_SAVE:
          return 'Обработка веера'
        case UserAction.FINAL_REPORT:
          return 'Формирование итоговой выгрузки'
        default:
          return v
      }
    },
  },
  {
    text: 'Файл',
    value: 'filename',
    sortable: false,
  },
]

export default {
  extends: BTableSimple,
  props: {
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getFilename({ filename, file_id }) {
      if (!filename || !file_id) {
        return ''
      }
      const fApi = new MarksFilesApi()
      return `
      <a 
      style="color: #2196f3; text-decoration: underline;" 
      href="${fApi.download(file_id)}" 
      download="${filename}">${filename}</a>`
    },
  },
}
</script>
